import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const PaintingGroups = ({
  getGroups,
  hasLoaded,
  paintingCurrency,
  paintingGroups,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      collectionsPath={paths.PAINTING_COLLECTIONS}
      currency={paintingCurrency}
      getGroups={getGroups}
      hasLoaded={hasLoaded}
      items={paintingGroups}
      student={student}
      title={messages.subactivity.painting}
    />
  );
};

PaintingGroups.propTypes = {
  getGroups: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  paintingCurrency: PropTypes.shape({}).isRequired,
  paintingGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.paintingGroups.getHasLoaded(state),
  paintingCurrency: selectors.paintingGroups.getCurrencyData(state),
  paintingGroups: selectors.paintingGroups.getGroupsData(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.painting,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(PaintingGroups);
